import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectByIdQuery } from '../../../../types/graphqlTypes';
import { SyncConfig } from './syncFromGraphQL';

type Project = ProjectByIdQuery['projectById'];
type CustomClass = NonNullable<Project['customClasses']>[number];

type SceneClass = {
  identifier: string;
  name: string;
  code: number;
  color: [number, number, number, number];
  custom?: boolean;
};

export function createSyncClassificationsConfig({ viewer, customClasses }: { viewer: NonNullable<RendererContextType['viewer']>; customClasses: NonNullable<Project['customClasses']> }): SyncConfig<CustomClass, SceneClass> {
  return {
    getSourceItems: () => customClasses,
    getSceneItems: () => viewer.classificationsInfo.classes.filter((c: SceneClass) => c.custom),
    getSourceIdentifier: (item) => item.id,
    getSceneIdentifier: (item) => item.identifier,
    update: (source, scene) => {
      const color: [number, number, number, number] = [source.color.r / 255, source.color.g / 255, source.color.b / 255, source.color.a];
      return scene.name === source.name && scene.color === color ? 'unchanged' : 'recreate';
    },
    create: (source) => {
      const color: [number, number, number, number] = [source.color.r / 255, source.color.g / 255, source.color.b / 255, source.color.a];
      return {
        identifier: source.id,
        name: source.name,
        code: source.code,
        color,
      } as SceneClass;
    },
    addToScene: (item) => {
      viewer.classificationsInfo.addCustomClass({
        identifier: item.identifier,
        name: item.name,
        code: item.code,
        color: item.color,
      });
    },
    removeFromScene: (item) => {
      viewer.classificationsInfo.removeCustomClass({ identifier: item.identifier });
    },
  };
}
